import { render, staticRenderFns } from "./supplements.vue?vue&type=template&id=3a4bff00&scoped=true&"
import script from "./supplements.vue?vue&type=script&lang=js&"
export * from "./supplements.vue?vue&type=script&lang=js&"
import style0 from "./supplements.vue?vue&type=style&index=0&id=3a4bff00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4bff00",
  null
  
)

export default component.exports